<template>
	<div :class="contextualClasses" class="v-contextual v-contextual--content">
		<div :class="triggerClasses" class="v-contextual__trigger">
			<slot :on="on" :toggle="toggle" name="trigger"/>
		</div>
		<div
			v-show="on"
			:id="menuId"
			:aria-hidden="!on"
			:aria-labelledby="triggerId"
			:class="contentClasses" class="v-contextual__content">
			<slot :on="on" :toggle="toggle"/>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			on: false,
		};
	},

	computed: {
		contextualClasses() {
			return {
				"v-contextual--content--on": this.on,
			};
		},
		triggerClasses() {
			return {
				"v-contextual__trigger--on": this.on,
			};
		},
		contentClasses() {
			return {
				"v-contextual__content--on": this.on,
			};
		},
		triggerId() {
			return "v-contextual__trigger--" + this.id;
		},
		menuId() {
			return "v-contextual__content--" + this.id;
		},
	},

	props: {
		id: {
			type: String,
			default() {
				return String(this._uid);
			},
		},
		disabled: {
			type: Boolean,
			default() {
				return false;
			},
		},
	},

	methods: {
		toggle() {
			this.on = !this.on;
			this.$emit("toggled", this.on);
		},
		show() {
			if (!this.on) {
				this.toggle();
			}
		},
		hide() {
			if (this.on) {
				this.toggle();
			}
		},
		preventScroll(e) {
			if (!this.on) {
				return;
			}
			e.preventDefault();
		},
	},

	created: function () {
		window.addEventListener("scroll", this.preventScroll, true);
		window.addEventListener("click", function (e) {
			if (!this.$el.contains(e.target)) {
				this.hide();
			}
		}.bind(this));
	},
};
</script>
